import { Component, Element, h, Host, Prop } from '@stencil/core';

import { ClassNames } from '../../utils/interfaces';

@Component({
  tag: 'patternlib-flyoutmenu-item',
  styleUrl: 'patternlib-flyoutmenu-item.scss',
  shadow: true,
})
export class PatternlibFlyoutmenuItem {
  private hasIconSlot: boolean;

  @Element() hostElement: HTMLPatternlibFlyoutmenuItemElement;

  /**
   * Set the Flyoutmenu item label
   */
  @Prop() label?: string;

  /**
   * Set the Flyoutmenu item detail label
   */
  @Prop() detail?: string;

  /**
   * Set the Flyoutmenu item id
   */
  @Prop() itemId?: number | string;

  /**
   * Define the Flyoutmenu item width
   */
  @Prop() width?: string = '100%';

  /**
   * Disable the Flyoutmenu item
   */
  @Prop({ reflect: true }) disabled: boolean;

  /**
   * Set a hyperlink
   */
  @Prop() href?: string = '';

  /**
   * Define the target of the hyperlink
   */
  @Prop() target?: 'blank' | 'parent' | 'self' | 'top' = 'blank';

  /**
   * Control the text-overflow behavior of the item
   */
  @Prop() overflow: 'ellipsis' | 'unset' = 'ellipsis';

  /**
   * Define the text style
   */
  @Prop() type?: 'default' | 'subtle' = 'default';

  componentWillLoad() {
    this.hasIconSlot = this.hostElement.querySelector('[slot="icon-left"]') !== null;
  }

  render() {
    const flyoutmenuItemClass: ClassNames = {
      'flyoutmenu-item': true,
      'disabled': this.disabled,
      'subtle': this.type === 'subtle',
    };

    const textOverflowControlClass: ClassNames = {
      ellipsis: this.overflow === 'ellipsis',
    };

    const hostStyle = { pointerEvents: this.disabled ? 'none' : undefined };
    const flyoutmenuItemStyle = { width: `${this.width}` };

    return (
      <Host style={hostStyle}>
        <div class="overflow-hidden">
          <a href={this.href != '' ? `${this.href}` : undefined} target={`_` + `${this.target}`}>
            <button class={flyoutmenuItemClass} style={flyoutmenuItemStyle} disabled={this.disabled} title={this.label}>
              <div class="flex items-center">
                {this.hasIconSlot && (
                  <div class="flex mr-[8px] h-[24px]">
                    <slot name="icon-left" />
                  </div>
                )}
                <span class={textOverflowControlClass}>{this.label}</span>
                {this.detail && <span class="ml-[4px] text-gray-400">{this.detail}</span>}
              </div>
            </button>
          </a>
        </div>
      </Host>
    );
  }
}
